export default __webpack_public_path__ + "static/media/Potato-bag.48230292.png";